import type { PropsWithChildren } from "react";

import type { EnsureOAuthTokenFunc } from "@/services/oauth-service";

import type { MondayService } from "../../services/monday-service";
import WithOAuthEnabled from "./WithOAuthEnabled";
import WithValidLicense from "./WithValidLicense";

type Props = PropsWithChildren<{
  mondayService: MondayService;
  oauthService: EnsureOAuthTokenFunc;
}>;

// This aggregates all cross-cutting concerns into a single component that wraps the
// It is responsible for:
// - Ensuring that the Monday context is available
// - Ensuring that the license is valid
// Child components should just assume everything is available and not worry about it
export default function WithContexts({ mondayService, oauthService, children }: Props) {
  return (
    <WithValidLicense mondayService={mondayService}>
      <WithOAuthEnabled ensureOAuthToken={oauthService} mondayService={mondayService}>
        {children}
      </WithOAuthEnabled>
    </WithValidLicense>
  );
}
